export const validation = {
  headingMaxChar: 50,
  paragraphMaxChar: 100,
  title: { required: true },
  headerSocials: {
    min: 0,
    max: 5
  }
}